import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useLanguage } from "@/i18n/LanguageContext";
import { WA, resolveMediaUrl } from "@/lib/api";
import { useProductMenu } from "@/hooks/useProductMenu";

const Footer = () => {
  const { settings } = useSettings();
  const { t, lang } = useLanguage();
  const s = settings || {};
  const wa = WA(s.whatsapp_number, s.whatsapp_template);

  const products = useProductMenu(lang);

  const help = [
    { to: "/tentang", label: t("footer.aboutUs") },
    { to: "/layanan", label: t("nav.services") },
    { to: "/faq", label: t("nav.faq") },
    { to: "/kontak", label: t("nav.contact") },
  ];

  return (
    <footer className="sas-foot" data-testid="site-footer">
      <div className="sas-wrap grid md:grid-cols-4 gap-10">
        <div>
          {s.logo ? (
            <img src={resolveMediaUrl(s.logo)} alt={s.site_name || "Logo"} className="h-14 w-auto object-contain object-left mb-4 bg-white p-2 rounded-md" />
          ) : (
            <h4>PT Mandala Cahaya Sentosa</h4>
          )}
          <p>{s.tagline || t("footer.taglineFallback")}</p>
          <p className="mt-3">{t("footer.servicesLine")}</p>
          <div className="flex gap-3 mt-4">
            {s.social?.instagram && <a href={s.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={18} /></a>}
            {s.social?.facebook && <a href={s.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook size={18} /></a>}
            {s.social?.linkedin && <a href={s.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><Linkedin size={18} /></a>}
            {s.social?.youtube && <a href={s.social.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><Youtube size={18} /></a>}
          </div>
        </div>
        <div>
          <h4>{t("nav.products")}</h4>
          <ul>
            {products.map((p) => (
              <li key={p.label}><Link to={p.to}>{p.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4>{t("footer.help")}</h4>
          <ul>
            {help.map((p) => (
              <li key={p.to}><Link to={p.to}>{p.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4>{t("footer.contact")}</h4>
          <ul>
            {s.phone ? <li className="flex gap-2 items-start"><Phone size={15} className="mt-1" /> <a href={`tel:${String(s.phone).replace(/\s/g, "")}`}>{s.phone}</a></li> : null}
            {s.phone ? <li className="flex gap-2 items-start"><Phone size={15} className="mt-1" /> <a href={wa}>{t("footer.whatsappUs")}</a></li> : null}
            {s.email ? <li className="flex gap-2 items-start"><Mail size={15} className="mt-1" /> <a href={`mailto:${s.email}`}>{s.email}</a></li> : null}
            {s.address ? <li className="flex gap-2 items-start"><MapPin size={15} className="mt-1 shrink-0" /> {s.address}</li> : null}
          </ul>
        </div>
      </div>
      <div className="sas-wrap sas-copy">
        Copyright © {new Date().getFullYear()} PT Mandala Cahaya Sentosa. {t("footer.rights")}
      </div>
    </footer>
  );
};

export default Footer;
